import axios from "axios";
import { getAccessToken } from "../slices/session";

/** Resolved on each request from Redux (see store.tsx). */
let resolvePromangCompanyId = () => undefined;

export function setPromangApiCompanyIdResolver(fn) {
  resolvePromangCompanyId = typeof fn === "function" ? fn : () => undefined;
}

export function applyPromangApiRequestContext(request) {
  request.headers = request.headers || {};

  const accessToken = getAccessToken();
  if (accessToken) {
    request.headers["Authorization"] = `Bearer ${accessToken}`;
  }

  if (!request.promangSkipCompanyHeader) {
    try {
      const companyId = resolvePromangCompanyId();
      if (companyId != null && String(companyId).trim() !== "") {
        request.headers["X-Promang-Company-Id"] = String(companyId).trim();
      }
    } catch (_) {
      /* ignore */
    }
  }

  delete request.promangSkipCompanyHeader;
  return request;
}

const instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    "Content-Type": "application/json",
    withCredentials: true,
  },
});

instance.interceptors.request.use(applyPromangApiRequestContext);

export default instance;
